import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

const MarketingFooter = () => (
  <footer>
    <div className="footer-brand">
      <div className="nav-logo">
        <Logo width="24" height="24" />
        memorloko
      </div>
      <div className="footer-copy">© 2026 Memorloko Inc.</div>
    </div>
    <div className="footer-links">
      <div className="footer-col">
        <h4>Product</h4>
        <a href="/#how-it-works">How It Works</a>
        <a href="/#pricing">Pricing</a>
        <a href="/#faq">FAQ</a>
      </div>
      <div className="footer-col">
        <h4>Company</h4>
        <Link to="/about">About</Link>
        <Link to="/about">Contact</Link>
      </div>
    </div>
  </footer>
);

export default MarketingFooter;
